// extracted by mini-css-extract-plugin
export default {"stickySection":"style_stickySection__L6zIq","mobileTabs":"style_mobileTabs__vknrW","tab":"style_tab__nh+uG","active":"style_active__2vJXA"};